import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useCurrency } from "@/lib/currency";

/**
 * Formatea precios con el idioma de ESTA visita (instancia i18n del
 * contexto React), no con la instancia global compartida del servidor.
 * Evita que el HTML del servidor y el del navegador difieran cuando
 * llegan visitas simultáneas en distintos idiomas.
 */
export function useFormatPrice() {
  const { i18n } = useTranslation();
  const { format } = useCurrency();
  const locale = i18n.language || "es";
  return useCallback(
    (amount: number | null, currency: string | null) => format(amount, currency, { locale }),
    [format, locale],
  );
}
